import React from 'react';
import { TextField } from '@mui/material';

/**
 * Standardized Date / DateTime / Time field for the application.
 * Ensures:
 * 1. Label always shrinks properly (no collision with dd/mm/yyyy).
 * 2. Proper placeholder handling.
 * 3. Clicking anywhere on the input opens native picker on supported browsers.
 * 4. Supports slotProps and InputLabelProps across MUI versions.
 */
export const AppDateField = ({
  type = 'date',
  label,
  value,
  onChange,
  onClick,
  placeholder,
  slotProps,
  InputLabelProps,
  ...props
}) => {
  return (
    <TextField
      type={type}
      label={label}
      value={value}
      onChange={onChange}
      onClick={(e) => {
        if (typeof onClick === 'function') onClick(e);
        if (e.target && typeof e.target.showPicker === 'function') {
          try {
            e.target.showPicker();
          } catch (_) {}
        }
      }}
      placeholder={placeholder || (type === 'date' ? 'dd/mm/yyyy' : type === 'datetime-local' ? 'dd/mm/yyyy, --:--' : '--:--')}
      slotProps={{
        ...slotProps,
        inputLabel: {
          shrink: true,
          ...slotProps?.inputLabel,
        },
      }}
      InputLabelProps={{
        shrink: true,
        ...InputLabelProps,
      }}
      {...props}
    />
  );
};

export default AppDateField;
